module.exports = __webpack_public_path__ + "img/calculators.c488c58f.svg";